import { Checkbox, Form, Space } from "antd";
import React, { useState } from "react";

export default function CheckBoxField(props) {

    const { data = {}, contact = {}, label_class = "", label_help_class = "", label_description_class = "" } = props;

    const {
        id = "",
        label = "Checkbox",
        type = "checkbox",
        description = "",
        required = false,
        required_message = "This field is required"
    } = data;

    const [error, setError] = useState(false);
    let defaultValue = contact.hasOwnProperty(id) ? true : false;

    return (
        <>
            <Space align="start">
                {required && <span style={{ color: "red" }}>*</span>}
                <Form.Item
                    name={id}
                    valuePropName="checked"
                    initialValue={defaultValue}
                    help = {(error) ? <div className={label_help_class}>{required_message || "This field is required."}</div> : ""}
                    rules={required ? [
                        {
                            validator: (_, value) => {
                                if (value) {
                                    setError(false);
                                    return Promise.resolve();
                                } else {
                                    setError(true);
                                    return Promise.reject(new Error(required_message));
                                }
                            }
                        }
                    ] : []}
                    extra={(description && <span className={label_description_class}>{description}</span>)}
                >
                    <Checkbox><div className={label_class}>{label}</div></Checkbox>
                </Form.Item>
            </Space>
           
        </>
    );
}
